export default __webpack_public_path__ + "static/media/a026-example7.d0b9686b.jpg";